import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "payment-requests-table-column-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_button = _resolveComponent("bs-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.paymentRequest.status && _ctx.paymentRequest.status.id === 62)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_bs_button, {
            size: "small",
            color: "royal-blue",
            onClick: _ctx.onPay
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Оплатить ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_bs_button, {
            size: "small",
            color: "red",
            onClick: _ctx.onDecline
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Отказать ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}